import React from "react";
import {InputAdornment} from "@mui/material";
import {Colors} from "@bounce/shared/ui";
import {TextField} from "../../../../ui/components";

const NUMBER_FIELD_WIDTH = 96;
const MIN_DIGITS = 1;
const DIGIT_WIDTH_PADDING_CH = 0.5;
const BLOCKED_KEYS = new Set(["-", "e", "E"]);

type Props = {
  value: number | "";
  onChange: (next: number | "") => void;
  ariaLabel: string;
  error?: boolean;
  suffix?: string;
};

const NumberField = ({value, onChange, ariaLabel, error = false, suffix}: Props) => (
  <TextField
    size="small"
    type="number"
    value={value}
    onChange={(event) => onChange(event.target.value === "" ? "" : Number(event.target.value))}
    onKeyDown={(event) => {
      if (BLOCKED_KEYS.has(event.key)) event.preventDefault();
    }}
    error={error}
    slotProps={{htmlInput: {min: 1, "aria-label": ariaLabel}}}
    InputSx={suffix ? {alignItems: "center"} : undefined}
    InputProps={
      suffix
        ? {
            endAdornment: (
              <InputAdornment
                position="end"
                disableTypography
                sx={{font: "inherit", color: Colors.grey._600, whiteSpace: "nowrap"}}
              >
                {suffix}
              </InputAdornment>
            ),
          }
        : undefined
    }
    sx={{
      width: suffix ? "auto" : NUMBER_FIELD_WIDTH,
      ...(suffix && {
        "& input": {width: `${Math.max(String(value).length, MIN_DIGITS) + DIGIT_WIDTH_PADDING_CH}ch`},
      }),
      backgroundColor: Colors.bw.white,
      borderRadius: "8px",
      "& input[type=number]": {MozAppearance: "textfield"},
      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
    }}
  />
);

export default NumberField;
